"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = void 0;
exports.constants = {
    COLLECTION_PATH_CATEGORY_TEMPLATE: "category_templates",
    COLLECTION_PATH_SUBJECT_TEMPLATE: "subject_templates",
    COLLECTION_PATH_GROUP_TEMPLATE: "group_templates",
    COLLECTION_PATH_LEVEL_TEMPLATE: "level_templates",
    COLLECTION_PATH_MODULE_TEMPLATE: "module_templates",
    COLLECTION_PATH_SPACED_REP_MODULE_CONFIG: "spaced_rep_module_configs",
    COLLECTION_PATH_CONCEPT_TEMPLATE: "concept_templates",
    COLLECTION_PATH_CARD_TEMPLATE: "card_templates",
    COLLECTION_PATH_STUDY_ORDER_TEMPLATE: "study_order_templates",
    COLLECTION_PATH_USER: "users",
    COLLECTION_PATH_PRIVATE_INFO: "private_info",
    COLLECTION_PATH_CONCEPT_MATERIAL: "concept_materials",
    COLLECTION_PATH_CONCEPT_REQUEST: "concept_requests",
    COLLECTION_PATH_ASSET: "assets",
    COLLECTION_PATH_CUSTOM_MODULE_PLAN: "custom_module_plans",
    COLLECTION_PATH_SELECTED_CONCEPT_MATERIAL: "selected_concept_materials",
    COLLECTION_PATH_SELECTED_CARD_TEMPLATE: "selected_card_templates",
    COLLECTION_PATH_SELECTED_ORIGINAL_CARD_TEMPLATE: "original",
    COLLECTION_PATH_USER_FEEDBACK: "user_feedbacks",
    COLLECTION_PATH_MAILCHIMP_USER: "mailchimp_users",
    COLLECTION_PATH_AUTH_CODE_RECORD: "auth_code_records"
};
